import { Search } from "lucide-react";

export const Wordmark = ({ compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="wordmark">
    <span className="grid h-7 w-7 place-items-center rounded-lg bg-gradient-to-br from-[#ff8a4c] via-[#ffc42e] to-[#ff8a4c] text-[#0b100d] shadow-[0_4px_16px_rgba(255,138,76,0.35)]">
      <Search strokeWidth={2.8} className="h-4 w-4" aria-hidden="true" />
    </span>
    {!compact && (
      <span className="text-[17px] font-semibold tracking-tight text-[#f3f5f3]">
        WonderSearch
      </span>
    )}
  </span>
);
